import { render } from "./singleBlock.vue?vue&type=template&id=cd8132e4"
import script from "./singleBlock.vue?vue&type=script&lang=js"
export * from "./singleBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__